var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCalendar = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#EDF2F7",
    width: 34,
    height: 34,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 8c.295 0 .536.238.536.531v1.594h6.428V8.531c0-.293.241-.531.536-.531.295 0 .536.238.536.531v1.594h1.071c1.182 0 2.143.951 2.143 2.125v10.625C25 24.047 24.04 25 22.857 25H12.143A2.135 2.135 0 0 1 10 22.875V12.25c0-1.174.96-2.125 2.143-2.125h1.071V8.531c0-.293.241-.531.536-.531zm10.179 6.375H11.07v8.5c0 .588.48 1.063 1.072 1.063h10.714c.593 0 1.072-.475 1.072-1.063v-8.5zm-1.072-3.188H12.143c-.592 0-1.072.475-1.072 1.063v1.063H23.93V12.25c0-.588-.48-1.063-1.072-1.063z",
    fill: "#1A202C",
    fillRule: "nonzero",
    stroke: "#1A202C",
    strokeWidth: 0.75
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar.4c557995.svg";
export { ForwardRef as ReactComponent };